// local
// export const wpApi = 'http://baileson-brewing.local/wp-json/brewery';
export const wpApi =
  "https://baileson-brewing.flywheelsites.com/wp-json/brewery";

// staging
//export const wpApi = 'http://api.baileson.c50dev.com/wp-json/brewery';

// prod
//export const wpApi = 'http://api.baileson.com/wp-json/brewery';



// WEBPACK FOOTER //
// ./src/config.js